import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import moment from 'moment';

import { visibleAdjustments } from 'util/adjustmentUtils';


const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});


 const TransactionAdjustments = (props) => {
  const { transaction, currencySymbol = '$' } = props;
  const classes = useStyles();



  
  const paymentTime = (time) => {
    if (!time) {
      return '';
    }
    if (typeof time === 'object' && '_seconds' in time) {
      return  moment(new Date(time._seconds * 1000)).format('DD/MM/YYYY HH:mm:ss')
    }
    return moment(time).format('DD/MM/YYYY HH:mm:ss')
  };

  // A $0 card surcharge is left out; with nothing else to show, so is the table.
  const adjustments = visibleAdjustments(transaction && transaction.adjustments);
  if (adjustments.length === 0) {
    return null;
  }

  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell>Adjustment Type </TableCell>
            <TableCell align="right">Percentage</TableCell>
            <TableCell align="right">Adjustment amount</TableCell>
            <TableCell align="right">Time</TableCell>
          
          </TableRow>
        </TableHead>
        <TableBody>
          {adjustments.map((row, index) => (
            <TableRow key={`${row.adjustmentType}-${index}`}>
              <TableCell component="th" scope="row">
                {row.adjustmentType}
              </TableCell>
              <TableCell align="right">{row.percentageValue}</TableCell>
              <TableCell align="right">{currencySymbol}{(Number(row.price) || 0).toFixed(2)}</TableCell>
              <TableCell align="right">{paymentTime(row.timeCreated)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

TransactionAdjustments.propTypes = {
  transaction: PropTypes.object,
  currencySymbol: PropTypes.string,
};

export default TransactionAdjustments;
